import http from "@/utils/request";

export const handleEnter = (store: any, data: any) => {
	return http({ path: "/web/sidekick/addEvent", method: "get", params:data });
};
